import '../LandingPage.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, provider } from '../firebase';
import { signInWithPopup } from 'firebase/auth';
import SiteService from './SiteService';
import FreeConsumptionStepper from './Rating/FreeConsumptionStepper';
import QRCode from 'react-qr-code';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userData = {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        provider: 'google',
      };
      await SiteService.addUser(userData);
      navigate('/');
    } catch (error) {
      console.error('Google ile giriş yapılamadı:', error);
    }
  };

  return (
    <div className="landing-page">
      <div className="landing-content">
        <div className="text-center mb-5">
          <h1 className="fw-bold display-5">🔌 Süzme Sayaç Hesaplama</h1>
          <p className="lead text-muted">
            Elektrik faturasını süzme sayaçlara profesyonel hesaplama yöntemleri ile adil şekilde paylaştırın
          </p>
        </div>

        <FreeConsumptionStepper />

        {/* Mobil Uygulama Duyurusu */}
        <div className="mobile-app-section text-center my-5 p-4" style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '16px',
          color: 'white'
        }}>
          <h3 className="mb-3">📱 Mobil Uygulamalarımız</h3>
          <p className="mb-4" style={{ fontSize: '1.1rem' }}>
            Süzme Sayaç uygulamasını artık cebinizde taşıyın!<br />
            Dilediğiniz zaman, dilediğiniz yerden hesaplama yapın.
          </p>
          
          <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap mb-4">
            {/* iOS App Store Badge */}
            <a 
              href="https://apps.apple.com/app/süzme-sayaç/id6751746732" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ display: 'inline-block' }}
            >
              <img 
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/tr-tr?size=250x83&amp;releaseDate=1727913600" 
                alt="App Store'dan İndir"
                style={{ height: '50px' }}
              />
            </a>

            {/* Android Google Play Badge (Yakında) */}
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                alt="Google Play'den İndir"
                style={{ height: '50px', opacity: 0.5, filter: 'grayscale(100%)' }}
              />
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                background: 'rgba(0,0,0,0.8)',
                padding: '4px 12px',
                borderRadius: '4px',
                fontSize: '0.85rem',
                fontWeight: 'bold',
                whiteSpace: 'nowrap'
              }}>
                ÇOK YAKINDA
              </div>
            </div>
          </div>

          {/* QR Code Bölümü (Opsiyonel) */}
          <div className="mt-4 pt-4" style={{ borderTop: '1px solid rgba(255,255,255,0.3)' }}>
            <p className="mb-3" style={{ fontSize: '0.95rem' }}>
              📲 <strong>Mobil cihazınızdan QR kodu okutarak hızlıca indirin:</strong>
            </p>
            <div style={{
              background: 'white',
              padding: '15px',
              borderRadius: '12px',
              display: 'inline-block'
            }}>
              <QRCode 
                value="https://apps.apple.com/app/süzme-sayaç/id6751746732"
                size={150}
                level="H"
              />
            </div>
            <p className="mt-2" style={{ fontSize: '0.8rem', opacity: 0.9 }}>
              iOS için App Store'a yönlendirir
            </p>
          </div>

          <div className="mt-4">
            <small style={{ opacity: 0.9 }}>
              ✨ Tüm verileriniz senkronize • 🔔 Bildirimler • 📊 Detaylı raporlar
            </small>
          </div>
        </div>

        <div className="text-center mt-5">
          <h5 className="mb-3">🔐 Giriş Yapın</h5>
          <p className="text-muted mb-3">
            Ana ve süzme sayaçlarınızı tanımlayıp aylık fatura paylaştırmak için Google hesabınızla giriş yapabilirsiniz.
          </p>
          <button className="btn btn-primary btn-lg" onClick={handleLogin}>
            Google ile Giriş Yap
          </button>
        </div>

        <footer className="text-center mt-5 text-muted small">
          <hr />
          <p>Süzme Sayaç Uygulaması &copy; {new Date().getFullYear()} | info@suzmesayac.com</p>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;